import InputTypesEnum from '../../../Enums/InputTypesEnum';
import ValidityHelper from '../../../Helpers/ValidityHelper';
import PaymentExportAllExportService from '../../../Services/PaymentExportAllExportService';
import UploadItem from './UploadItem';

export default class UploadPanelDescription {
  //-----------------------------------------------------
  //---------------- Fields for General Edit Panel ------
  //-----------------------------------------------------

  static titleForEdit = 'Upload Excel File';
  static titleForCreate = 'Upload Excel File';
  static labelForSubmitButton = 'Upload';
  static itemType = UploadItem;
  static serviceFunction = PaymentExportAllExportService.postXmlFile;
  static nameOfTheIdField = 'LookupItemId';

  getSelected() {}

  getSearchParameters() {}

  getAllItemInTheSearchAreSelected() {}

  // The following field can be an array or a function that returns an array.
  static pagesInGeneralEditWizzard = [
    {
      label: 'Upload Excel',
      fields: [
        {
          fieldName: 'DownloadTemplateLink',
          label: 'Download Template',
          className: 'col-12',
          type: InputTypesEnum.Link,
          displayHyperlink: true,
          validityChecker: ValidityHelper.AlwaysFlawless,
        },
        {
          fieldName: 'file',
          label: 'Excel File',
          className: 'col-12',
          type: InputTypesEnum.FileUploadField,
          acceptedTypes: '.xlsx, .xls',
          validityChecker: ValidityHelper.forRequiredFileField,
        },
      ],
    },
  ];

  //-----------------------------------------------------
  //--------- End of Fields for General Edit Panel ------
  //-----------------------------------------------------
  // static getLabel (item)
  // {
  //     switch (item.LookupId)
  //     {
  //         case 108:
  //             return 'Create PTO entry in timesheet for this type';
  //         default:
  //             return 'Misc';
  //     }
  // }
}
